module.exports = __webpack_public_path__ + "static/app-icon@2x-b8bc289b73ed653ad646df35300257e5.png";